<footer class="footer">
  <div class="footer__company">
    <img src="../../../assets/images/logo.svg" class="footer__company-logo" />
    <span class="footer__company-name">Grid Dynamics</span>
  </div>
  <div class="footer__links">
    <a class="footer__link" href="mailto:ingrid-support@griddynamics.com">
      <svg class="footer__link-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="none" d="M0 0h24v24H0z"></path>
        <path
          class="footer__link-icon-content"
          d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
        ></path>
      </svg>
      <span class="footer__link-text">Help & feedback</span>
    </a>
  </div>
  <div class="footer__divider"></div>
  <span class="footer__copyright">Grid Dynamics © 2006-{{ currentYear }}</span>
</footer>
